import { SpecialGradeLevel } from '@suntex.fim/enums';

export enum RankingsSlug {
  SchoolInternational = 'school-international',
  SchoolNation = 'school-nation',
  SchoolState = 'school-state',
  SchoolSystem = 'school-system',
  SchoolDistrict = 'school-district',

  TeamInternational = 'team-international',
  TeamNation = 'team-nation',
  TeamState = 'team-state',
  TeamSystem = 'team-system',
  TeamDistrict = 'team-district',
  TeamSchool = 'team-school',

  PlayerInternational = 'player-international',
  PlayerNation = 'player-nation',
  PlayerState = 'player-state',
  PlayerSystem = 'player-system',
  PlayerDistrict = 'player-district',
  PlayerSchool = 'player-school',

  EducatorNation = 'educator-nation',
  EducatorState = 'educator-state',
  EducatorSystem = 'educator-system',
  EducatorDistrict = 'educator-district',
  EducatorSchool = 'educator-school',

  FamilyNation = 'family-nation',
  FamilyState = 'family-state',
  FamilySystem = 'family-system',
  FamilyDistrict = 'family-district',
  FamilySchool = 'family-school',

  CombinedFamilyNation = 'combined-family-nation',
  CombinedFamilyState = 'combined-family-state',
  CombinedFamilySystem = 'combined-family-system',
  CombinedFamilyDistrict = 'combined-family-district',
  CombinedFamilySchool = 'combined-family-school',
}

export const rankingSections = [
  {
    title: 'Top Schools',
    key: 'school',
    levels: [
      { slug: RankingsSlug.SchoolInternational, label: 'International' },
      { slug: RankingsSlug.SchoolNation, label: 'National' },
      { slug: RankingsSlug.SchoolState, label: 'State' },
      { slug: RankingsSlug.SchoolSystem, label: 'School System' },
      { slug: RankingsSlug.SchoolDistrict, label: 'School District' },
    ],
  },
  {
    title: 'Top Teams',
    key: 'team',
    levels: [
      { slug: RankingsSlug.TeamInternational, label: 'International' },
      { slug: RankingsSlug.TeamNation, label: 'National' },
      { slug: RankingsSlug.TeamState, label: 'State' },
      { slug: RankingsSlug.TeamSystem, label: 'School System' },
      { slug: RankingsSlug.TeamDistrict, label: 'School District' },
      { slug: RankingsSlug.TeamSchool, label: 'School' },
    ],
  },
  {
    title: 'Top Players',
    key: 'player',
    levels: [
      { slug: RankingsSlug.PlayerInternational, label: 'International' },
      { slug: RankingsSlug.PlayerNation, label: 'National' },
      { slug: RankingsSlug.PlayerState, label: 'State' },
      { slug: RankingsSlug.PlayerSystem, label: 'School System' },
      { slug: RankingsSlug.PlayerDistrict, label: 'School District' },
      { slug: RankingsSlug.PlayerSchool, label: 'School' },
    ],
  },
  {
    title: 'Top Educators',
    key: 'educator',
    levels: [
      { slug: RankingsSlug.EducatorNation, label: 'National' },
      { slug: RankingsSlug.EducatorState, label: 'State' },
      { slug: RankingsSlug.EducatorSystem, label: 'School System' },
      { slug: RankingsSlug.EducatorDistrict, label: 'School District' },
      { slug: RankingsSlug.EducatorSchool, label: 'School' },
    ],
  },
  {
    title: 'Top Family Players',
    key: 'family',
    levels: [
      { slug: RankingsSlug.FamilyNation, label: 'National' },
      { slug: RankingsSlug.FamilyState, label: 'State' },
      { slug: RankingsSlug.FamilySystem, label: 'School System' },
      { slug: RankingsSlug.FamilyDistrict, label: 'School District' },
      { slug: RankingsSlug.FamilySchool, label: 'School' },
    ],
  },
  {
    title: 'Top Family Teams',
    key: 'combinedFamily',
    levels: [
      { slug: RankingsSlug.CombinedFamilyNation, label: 'National' },
      { slug: RankingsSlug.CombinedFamilyState, label: 'State' },
      { slug: RankingsSlug.CombinedFamilySystem, label: 'School System' },
      { slug: RankingsSlug.CombinedFamilyDistrict, label: 'School District' },
      { slug: RankingsSlug.CombinedFamilySchool, label: 'School' },
    ],
  },
] as const;

const defaultGradeOptions = [
  SpecialGradeLevel.Kindergarten,
  SpecialGradeLevel.Grade1,
  SpecialGradeLevel.Grade2,
  SpecialGradeLevel.Grade3,
  SpecialGradeLevel.Grade4,
  SpecialGradeLevel.Grade5,
  SpecialGradeLevel.Grade6,
  SpecialGradeLevel.Grade7,
  SpecialGradeLevel.Grade8,
];

export const playerGradeOptions: readonly SpecialGradeLevel[] = [
  SpecialGradeLevel.AllGrades,
  ...defaultGradeOptions,
] as const;

export const teamsGradeOptions: readonly SpecialGradeLevel[] = [
  SpecialGradeLevel.AllGrades,
  ...defaultGradeOptions,
] as const;

export const schoolGradeOptions: readonly SpecialGradeLevel[] = [
  SpecialGradeLevel.Top100Students,
  SpecialGradeLevel.Top100StudentsUpTo200,
  SpecialGradeLevel.Top200Students,
  SpecialGradeLevel.Top500Students,
  ...defaultGradeOptions,
  SpecialGradeLevel.Top10Teachers,
  SpecialGradeLevel.Top10FamilyLink,
] as const;
